<template>
  <v-autocomplete clearable="" :label="etiket" hide-details append-icon="search" @input="returnvalue()" :loading="loading" :items="statecari"
    item-text="text" item-value="id" cache-items="" v-model="Carihesap" :search-input.sync="searchcari">
  </v-autocomplete>
</template>

<script>
  import auth from '../../../api/auth'


  export default {
    props: ["etiket", "searcharama", "ilkdeger"],

    data() {
      return {
        Carihesap: '',
        loading: false,
        statecari: [],
        searchcari: '',
        index1: 0,
      }
    },
    beforeMount: beforeMount,

    watch: {
      searchcari(val) {
        val && this.carigetir(val)
      }
    },
    methods: {
      returnvalue() {
        this.$emit('input', this.Carihesap)
      },
      carigetir: carigetir
    }
  }

  function beforeMount() {
    if (this.index1 == 0) {
      var v = this.ilkdeger
      this.index1 = 1
      if (v != null && v != '') {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var CurrentInput = {
          Code: v,
          CompanyCode: credentials.SirketKodu
        }
        this.$http.post(auth.API_URL + 'api/Current/Get', CurrentInput, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {


          if (response.body.Code!= null) {
             var ilkkayit = {
            text: response.body.Code + '-' + response.body.Title,
            id: response.body.Code
          }
          this.statecari.push(ilkkayit)
          this.$emit('input', v)
          this.Carihesap = v
          } else {
             var ilkkayit = {
            text: v,
            id: v
          }
          this.statecari.push(ilkkayit)
          this.$emit('input', v)
          this.Carihesap = v
          }

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = response.body.StatusText
            this.snackbar = true
          }
        })


      } else {

      }
    }
  }


  function carigetir(v) {
    this.statecari = []
    if (v.length >= 0) {
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/CurrentSearch', {
          q: escape(v)
        }, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.statecari = response.body
          this.Error = false
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })
      }, 500)
    }
  }
</script>

<style>
</style>